document.addEventListener('DOMContentLoaded', () => {
  const isTablet = window.matchMedia("(min-width: 768px) and (max-width: 1023px)").matches;
  const isDesktop = window.matchMedia("(min-width: 1024px) and (max-width: 1189px)").matches;
  // const isDesktopLarge = window.matchMedia("(min-width: 1190px)").matches;

  const productsContainerEl = document.querySelector("#js-category-products");
  const filterContainerEl = document.querySelector("#js-category-filter");

  const productsItemsEl = productsContainerEl.querySelectorAll(".js-category-products__item");

  // Поиск
  const searchEl = document.querySelector("#js-category-search");
  const emptyEl = document.querySelector("#js-category-empty");

  if (searchEl) {
    searchEl.addEventListener("keyup", function () {
      let searchStr = this.value.toLowerCase();
      let searchValues = searchStr.split(" ").filter((elem) => elem !== "");
      if (searchValues && searchValues.length > 0) {
        productsItemsEl.forEach(item => {
          item.style.display = searchValues.some(value => item.textContent.toLowerCase().includes(value)) ? 'block' : 'none';
        });
      } else {
        productsItemsEl.forEach(item => {
          item.style.display = 'block';
        });
      }
      // Показ текста "товары не найдены" в случае если нет товаров удовлетворяющих условиям поиска
      let visibleProducts = productsItemsEl.filter(item => item.style.display !== 'none').length;
      emptyEl.classList.toggle("d-none", visibleProducts > 0);
    });
  }

  // Сортировка
  const sortEl = document.querySelector("#js-category-sort");
  if (sortEl) {
    sortEl.addEventListener("change", function () {
      const url = $(this).val();
      window.location.replace(url);
    });
  }

  // Показать/скрыть фильтры
  const filterTogglerEl = document.querySelector("#js-category-filter-toggler");
  if (filterTogglerEl) {
    filterTogglerEl.addEventListener("click", function () {
      const expanded = this.getAttribute("aria-expanded");

      this.querySelector(".dh-category-settings__icon--filter-on").classList.toggle("d-none");
      this.querySelector(".dh-category-settings__icon--filter-off").classList.toggle("d-none");

      productsContainerEl.classList.toggle(isTablet ? 'col-md-7' : isDesktop ? 'col-md-8' : 'col-lg-9');
      filterContainerEl.classList.toggle(isTablet ? 'col-md-5' : isDesktop ? 'col-md-4' : 'col-lg-3');

      if (expanded === "true") {
        productsContainerEl.style.setProperty("--columns", isTablet ? '1' : isDesktop ? '2' : '3');
        this.querySelector(".dh-category__settings-text").textContent = this.dataset.hideText;
      } else {
        productsContainerEl.style.setProperty("--columns", isTablet ? '2' : isDesktop ? '3' : '4');
        this.querySelector(".dh-category__settings-text").textContent = this.dataset.showText;
      }
    });
  }

  // Сброс фильтров
  const filterFormEl = document.querySelector('#js-category-filter-form');
  if (filterFormEl) {
    filterFormEl.addEventListener('reset', function (e) {
      e.stopPropagation();
      window.location.href = window.location.pathname;
    });
  }

  // Варианты товаров
  const colorVariantsEl = document.querySelectorAll(".js-product-card-select__color");
  if (colorVariantsEl) {
    colorVariantsEl.forEach(item => {
      item.addEventListener("click", function () {
        const id = this.dataset.productId;
        const currentVariantEl = this.closest(".js-category-products-item__variant");
        const productContainerEl = this.closest(".js-category-products__item");
        if (!this.classList.contains("active")) {
          currentVariantEl.classList.add("d-none");
          productContainerEl.querySelector(".js-category-products-item__variant[data-product-id='" + id + "']")
            .classList.remove("d-none");
        }
      });
    });
  }

  const radioVariantsEl = document.querySelectorAll(".js-product-card-select__radio");
  if (radioVariantsEl) {
    radioVariantsEl.forEach(item => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        const selectedId = Number(item.querySelector('input').value);
        const currentId = Number(item.closest(".js-category-products-item__variant").dataset.productId);
        const currentVariantEl = this.closest(".js-category-products-item__variant");
        const productContainerEl = this.closest(".js-category-products__item");
        if (currentId !== selectedId) {
          currentVariantEl.classList.add("d-none");
          productContainerEl.querySelector(".js-category-products-item__variant[data-product-id='" + selectedId + "']")
            .classList.remove("d-none");
        }
      });
    });
  }
});